import {useEffect, useState, useRef} from 'react';
import {FaPlus, FaRedo, FaTimes} from 'react-icons/fa';
import {CHAT_ATTACHMENT_ACCEPT, formatAttachmentSize} from './attachmentRules';

function MediaThumbnail({file}) {
    const [url, setUrl] = useState('');
    useEffect(() => {
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return;
        const source = URL.createObjectURL(file); setUrl(source);
        return () => URL.revokeObjectURL(source);
    }, [file]);
    return url ? <img className="chat-upload-thumbnail" src={url} alt=""/> : <span className="chat-upload-thumbnail" aria-hidden="true">{file.type?.startsWith('video/') ? '▶' : '▧'}</span>;
}

export default function AttachmentUploadQueue({uploads, disabled}) {
    const inputRef = useRef(null);
    return (
        <>
            {uploads.items.length > 0 ? (
                <div className="chat-upload-queue" aria-label="Attachments to send" aria-live="polite">
                    {uploads.items.map(item => (
                        <div className={`chat-upload-item is-${item.status}`} key={item.local_id}>
                            <MediaThumbnail file={item.file}/>
                            <div className="chat-upload-details">
                                <strong title={item.file.name}>{item.file.name}</strong>
                                <span>{formatAttachmentSize(item.file.size)} · {item.status_label}</span>
                                {item.status === 'uploading' ? <progress max="100" value={item.progress} aria-label={`Upload progress for ${item.file.name}`} /> : null}
                                {item.error ? <span className="chat-upload-error">{item.error.message || 'Upload failed'}</span> : null}
                            </div>
                            {item.status === 'error' ? (
                                <button type="button" aria-label={`Retry ${item.file.name}`} disabled={disabled} onClick={() => uploads.retry(item.local_id)}><FaRedo /></button>
                            ) : null}
                            <button type="button" aria-label={`Remove ${item.file.name}`} disabled={disabled} onClick={() => uploads.remove(item.local_id)}><FaTimes /></button>
                        </div>
                    ))}
                </div>
            ) : null}
            <button
                type="button"
                className="chat-attach-button"
                aria-label="Add photos or videos"
                title="Add photos (20 MB) or videos (100 MB)"
                disabled={disabled || uploads.atLimit}
                onClick={() => inputRef.current?.click()}
            >
                <FaPlus aria-hidden="true"/>
            </button>
            <input
                ref={inputRef}
                className="visually-hidden"
                type="file"
                multiple
                accept={CHAT_ATTACHMENT_ACCEPT}
                disabled={disabled || uploads.atLimit}
                onChange={event => {
                    uploads.addFiles(event.target.files);
                    event.target.value = '';
                }}
            />
        </>
    );
}
